<template>
    <div>
        <b-btn variant="warning" block @click="modal = true">
            Email Report
        </b-btn>
        <Cmodal
            v-model="modal"
            cancel-label="Cancel"
            centered size="md"
            title="Email Report"
            :tag="false"
            confirm-label="Send Email"
            :progressing="loading"
        >
            <template>
                <div class="mb-3">
                    Please enter the Email address to get a report copy.
                </div>
                <div>
                    <b-input-group prepend="Email Address">
                        <b-input name="Email Address" v-validate="'required'"/>
                    </b-input-group>
                </div>
                <b-alert :show="errors.any()" variant="danger" class="px-4">
                    <ul class="m-0 px-1" style="list-style: none">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        <li v-if="orderCredit == Subtotal">Please cancel tab instead of giving full credit.</li>
                    </ul>
                </b-alert>
            </template>
        </Cmodal>
    </div>
</template>

<script>
    import Cmodal from "./Cmodal";
    export default {
        name: "emailReport",
        components: {
            Cmodal
        },
        data () {
            return {
                modal: false,
                loading: false
            }
        }
    }
</script>

<style scoped>

</style>
